import { TrackWithCb } from '@rmc/webcx-web-libs';

export type TrackEventPropsType = {
	version: string;
	projectKey: string;
	campaignId: string;
	contentId: string;
	ratAccountId: string;
	ratServiceType: string;
	ratServiceId: string;
	isMobile: boolean;
	trackCb: () => void;
	message?: string;
	userId: string;
	sessionId: string;
	domainScopedSessionId: string;
	clientId: string;
	correlationId?: string | null;
	replacementId?: string;
	selector?: string | null;
	impressionId?: string;
	ratApiAccountSrc?: string;
	isPreview?: boolean;
};

export type TrackAppClickPropsType = TrackEventPropsType & {
	url: string;
};

export function TrackAppHit(rest: TrackEventPropsType) {
	return TrackWithCb({
		screen: 'METRIC',
		action: 'HIT',
		...rest,
	});
}
